/**
 * Installs the CSP style-nonce bridge, as a side effect of being imported.
 *
 * A module rather than a call in `main.tsx`, and that is not a style choice.
 * `import` declarations are hoisted: every imported module is fully evaluated
 * before the first statement of the importing module runs. A call placed
 * between the imports would therefore execute *after* React, RainbowKit and Lit
 * had already been evaluated — which is exactly the window this bridge exists
 * to cover.
 *
 * Modules are evaluated depth-first in the order they are imported, so this
 * file has no imports of its own beyond the function it calls, and `main.tsx`
 * imports it on its first line.
 */
import { installStyleNonce } from "@/lib/style-nonce";

installStyleNonce();
